import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TeiasoftToasterService {
  // Observable string sources
  private teiasoftToasterStartSource = new Subject<any>();

  // Observable string streams
  teiasoftToasterStart$ = this.teiasoftToasterStartSource.asObservable();

  toastId: number = 0;

  constructor() { }

  show(toastType:string, message:string){
    this.toastId++;
    this.teiasoftToasterStartSource.next(toastType + "|" + message + "|" + this.toastId);
  }
}
